import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { AddressComponent } from "./address.component";
import { FormErrorModule } from "src/app/pages/error/form-error/form-error.module";
import {AliceDateSeletorComponent} from '../address/AliceDateSeletor/AliceDateSeletor.component'

@NgModule({
    imports: [
        CommonModule,
        AutoCompleteModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        DividerModule,
        CheckboxModule,
        ButtonModule,
        InputMaskModule,
        InputTextModule,
        InputNumberModule,
        AutoCompleteModule,
        FormErrorModule,
        AliceDateSeletorComponent,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    declarations: [AddressComponent],
    exports: [AddressComponent]
})
export class AddressModule { }
